import { CrudService, httpClient, type HttpClient } from '../core'
import { projectMappingsEndpoints } from './project-mappings.endpoints'
import {
  projectMappingPageSchema,
  projectMappingSchema,
  type ProjectMappingCreateBody,
  type ProjectMappingDto,
  type ProjectMappingFilters,
  type ProjectMappingUpdateBody,
} from './project-mappings.schemas'

export class ProjectMappingsService extends CrudService<ProjectMappingDto, ProjectMappingCreateBody, ProjectMappingUpdateBody, ProjectMappingFilters> {
  constructor(http: HttpClient = httpClient) {
    super(http, projectMappingsEndpoints, { item: projectMappingSchema, page: projectMappingPageSchema })
  }
}

export const projectMappingsService = new ProjectMappingsService()
